import { ProductTagEditForm } from 'application/product-tag/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ProductTagService } from 'application/product-tag/services';
import { action } from 'mobx';

@applicationContext
class ProductTagEditViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new ProductTagService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'product-tag-edit',
            id: id,
            Form: ProductTagEditForm,
            authorization: 'portalSection.update',
            actions: () => {
                return {
                    get: async (id, opts) => {
                        const response = await service.get(id, opts);
                        return response.data;
                    },
                    update: async (resource) => {
                        const response = await service.update(resource);
                        return response.data;
                    },
                    create: async (resource) => {
                        const response = await service.create(resource);
                        return response.data;
                    }
                }
            },
            FormClass: ProductTagEditForm,
        });
    }

    onCreateError(err) {
        if (!this.errorActions.onCreateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Product Tag already exists.' : err.data.message : `Error occurred while trying to update a Product Tag.`
            );
            return;
        }
        return this.errorActions.onCreateError(err)
    }

    onUpdateError(err) {
        if (!this.errorActions.onUpdateError) {
            this.rootStore.notificationStore.error(
                err && err.data && err.data.message ? err.data.message === 'Resource already exists.' ? 'This Product Tag already exists.' : err.data.message : `Error occurred while trying to update a Product Tag.`
            );
            return;
        }
        return this.errorActions.onUpdateError(err);
    }

    @action.bound
    notifySuccessCreate() {
        this.rootStore.notificationStore.success('PRODUCT_TAG.CREATE.SUCCESS_CREATE');
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('PRODUCT_TAG.EDIT.SUCCESS_UPDATE', name);
    }
}

export default ProductTagEditViewStore;
